import { Download } from "lucide-react";
import { DATASHEET } from "@/content";

const STYLES = {
  dark: "border-white/15 bg-white/5 text-white hover:border-brand-orange hover:text-brand-orange",
  light: "border-slate-300 bg-white/70 text-brand-ink hover:border-brand-orange hover:text-brand-orange",
  solid: "border-brand-orange bg-brand-orange text-white hover:bg-brand-deep hover:border-brand-deep",
};

export const DownloadDatasheet = ({ variant = "light", testid = "download-datasheet-button", className = "", label = DATASHEET.label }) => (
  <a
    href={DATASHEET.url}
    download={DATASHEET.filename}
    data-testid={testid}
    className={`group inline-flex items-center gap-2.5 rounded-full border px-7 py-4 text-[15px] font-bold transition-colors duration-300 ${STYLES[variant]} ${className}`}
  >
    <Download className="h-[18px] w-[18px] transition-transform duration-300 group-hover:-translate-y-0.5" />
    {label}
  </a>
);
